var script = {
  name: 'PtNavBrandItem',
  props: {
    brandLogo: {
      type: String,
      required: true,
    },
    brandDestination: {
      type: String,
      default: null,
    },
  },
  methods: {
    computeTag: function computeTag() {
      return this.$router ? 'router-link' : 'a';
    },
    computeHref: function computeHref(tag) {
      // We've already checked the this.$router in computeTag,
      // so router-link means live router.
      // When deferring to Vue Router's router-link,
      // don't use the href attr at all.
      // Must return undefined for router-link to populate href.
      if (tag === 'router-link') { return undefined; }

      if (this.brandDestination) {
        return ("/" + (this.brandDestination));
      }

      // If nothing is provided use '#'
      return '/';
    },
  },
  render: function render(h) {
    var tag = this.computeTag();
    var href = this.computeHref(tag);
    var to = tag === 'router-link' && this.brandDestination
      ? ("/" + (this.brandDestination))
      : undefined;

    return h('div', { staticClass: 'pt-logo-container' }, [
      h(
        tag,
        {
          attrs: { href: href },
          props: { to: to },
        },
        [
          h('img', {
            attrs: { src: this.brandLogo },
          }) ]
      ) ]);
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  

  
  var NavBrandItem = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//

var script$1 = {
  name: 'PtTopBar',
  components: { NavBrandItem: NavBrandItem },
  props: {
    brandLogoSrc: {
      type: String,
      default: null,
    },
    brandDestination: {
      type: String,
      default: null,
    },
  },
};

/* script */
            var __vue_script__$1 = script$1;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "pt-top-bar" },
    [
      _vm.brandLogoSrc
        ? _c("nav-brand-item", {
            attrs: {
              "brand-logo": _vm.brandLogoSrc,
              "brand-destination": _vm.brandDestination
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("sidebar-placeholder"),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__$1 = undefined;
  /* scoped */
  var __vue_scope_id__$1 = undefined;
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var TopBar = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

var OutsideClick = {
  mounted: function mounted() {
    if (typeof document !== 'undefined') {
      document.documentElement.addEventListener('click', this._handleOutsideClick);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.documentElement.removeEventListener('click', this._handleOutsideClick);
    }
  },
  methods: {
    _handleOutsideClick: function _handleOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        if (this.onOutsideClick) {
          this.onOutsideClick();
        }
      }
    },
  },
};

//

var script$2 = {
  name: 'PtSideBar',
  components: { NavBrandItem: NavBrandItem },
  mixins: [OutsideClick],
  props: {
    brandLogoSrc: {
      type: String,
      default: null,
    },
    brandDestination: {
      type: String,
      default: null,
    },
  },
  data: function data() {
    return {
      isSidebarVisible: false,
    };
  },
  methods: {
    onIconClick: function onIconClick() {
      this.isSidebarVisible = !this.isSidebarVisible;

      if (this.isSidebarVisible) {
        this.$emit('onSidebarOpen');
      } else {
        this.$emit('onSidebarClose');
      }
    },
    onOutsideClick: function onOutsideClick() {
      if (!this.isSidebarVisible) { return; }

      this.isSidebarVisible = false;
    },
  },
};

/* script */
            var __vue_script__$2 = script$2;
            
/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "pt-sidebar-content" },
    [
      _c(
        "div",
        { staticClass: "pt-sidebar-icon", on: { click: _vm.onIconClick } },
        [_c("i", { staticClass: "fa fa-bars" })]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "pt-sidebar-slide" } }, [
        _vm.isSidebarVisible
          ? _c(
              "div",
              { staticClass: "pt-sidebar-body" },
              [
                _c(
                  "div",
                  { staticClass: "pt-sidebar-header-row" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "pt-sidebar-close-icon",
                        on: { click: _vm.onIconClick }
                      },
                      [_c("i", { staticClass: "fa fa-times" })]
                    ),
                    _vm._v(" "),
                    _vm.brandLogoSrc
                      ? _c("nav-brand-item", {
                          attrs: {
                            "brand-logo": _vm.brandLogoSrc,
                            "brand-destination": _vm.brandDestination
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._t("default")
              ],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  var __vue_inject_styles__$2 = undefined;
  /* scoped */
  var __vue_scope_id__$2 = undefined;
  /* module identifier */
  var __vue_module_identifier__$2 = undefined;
  /* functional template */
  var __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var SideBar = normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$3 = {
  name: 'PtNavItem',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: null,
    },
    to: {
      type: [String, Object],
      default: null,
    },
    callback: {
      type: Function,
      default: null,
    },
  },
  methods: {
    runCallback: function runCallback() {
      if (typeof this.callback === 'function') {
        this.callback();
      }
    },
  },
};

/* script */
            var __vue_script__$3 = script$3;
            
/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "pt-nav-item",
      class: {
        "cursor-not-allowed": _vm.disabled,
        "pt-nav-item-selected": _vm.selected
      }
    },
    [
      _vm.href && !_vm.disabled
        ? _c(
            "a",
            { attrs: { href: _vm.href, target: "_blank" } },
            [_vm._t("default")],
            2
          )
        : _vm.to && !_vm.disabled
        ? _c("router-link", { attrs: { to: _vm.to } }, [_vm._t("default")], 2)
        : _vm.callback && !_vm.disabled
        ? _c(
            "div",
            {
              staticClass: "pt-nav-item-callback",
              on: { click: _vm.runCallback }
            },
            [_vm._t("default")],
            2
          )
        : _c(
            "div",
            {
              staticClass: "pt-nav-item-regular uppercase",
              class: { "cursor-not-allowed": _vm.disabled }
            },
            [_vm._t("default")],
            2
          )
    ],
    1
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  var __vue_inject_styles__$3 = undefined;
  /* scoped */
  var __vue_scope_id__$3 = undefined;
  /* module identifier */
  var __vue_module_identifier__$3 = undefined;
  /* functional template */
  var __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var NavItem = normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    undefined,
    undefined
  );

export { TopBar as PtTopBar, SideBar as PtSideBar, NavItem as PtNavItem };
